import {toast} from "sonner"

export async function editHoursEndpoint(hoursObject, packageId) {
    const url = `${process.env.REACT_APP_API_URL}/admin/estudiante/personalizado/horas-compradas/actualizar/${packageId}`;
    const token = sessionStorage.getItem('token');

    try {
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(hoursObject)
        });

        const contentType = response.headers.get('content-type');
        const responseText = await response.text();

        if (!response.ok) {
            toast.error("Error al editar horas del Estudiante", responseText);    
            console.error('Server responded with:', responseText);
            throw new Error('Failed to edit student hours');
        }

        if (contentType && contentType.includes('application/json')) {
            toast.success("Paquete de horas editado con éxito");
            return JSON.parse(responseText);
        } else {
            console.log('Response is not JSON:', responseText);
            toast.success("Paquete de horas editado con éxito");
            return { message: responseText };
        }
    } catch (error) {
        console.error('Error editing hours for student:', error);
        throw error;
    }
}